<div class="corFonte bg-light">
  <div class="col-xs-12 col-lg-12">
    <div class="card bg-light cardCalculadora cardPrincipal">
      <div class="card-text">
        <div class="container">
          <br>
          <div class="card-subtitle corFonte" style="font-family: Arial;">
            <h5 class="">Cálculo de horas extras para 50%</h5>
          </div>
          <div class="row">
            <div class="col-sm">
              <div class="form-group corFonte">
                <label for="salarioBase_50">Salário Base</label>
                <input type="number" step="0.01" [(ngModel)]="salarioBase_50" class="form-control tamanhoCaixaTexto"
                  id="salarioBase50" aria-describedby="salarioBase_50">
                <small id="salarioBase_50" class="form-text text-muted corFonte hint">* Campo obrigatório.</small>
              </div>
            </div>
            <div class="col-sm">
              <div class="form-group corFonte">
                <label for="HoraMes">Hora/Mês</label>
                <input type="number" [(ngModel)]="horaMes_50" class="form-control tamanhoCaixaTexto" id="HoraMes">
              </div>
            </div>
            <div class="col-sm">
              <div class="form-group corFonte">
                <label for="salarioBase">Hora</label>
                <input type="number" [(ngModel)]="hora_50" class="form-control tamanhoCaixaTexto" id="salarioBase">
              </div>
            </div>
            <div class="col-sm">
              <div class="corFonte">
                <label for="Minuto">Minuto</label>
                <input type="number" min="0" max="59" [(ngModel)]="minuto_50" class="form-control tamanhoCaixaTexto"
                  id="Minuto">
              </div>
            </div>

          </div>
          <br>
          <div class="card-subtitle corFonte" style="font-family: Arial;">
            <h5 class="">Cálculo de horas extras para 80%</h5>
          </div>
          <div class="row">
            <div class="col-sm">
              <div class="form-group corFonte">
                <label for="salarioBase_80">Salário Base</label>
                <input type="number" step="0.01" [(ngModel)]="salarioBase_80" class="form-control tamanhoCaixaTexto"
                  id="salarioBase80" aria-describedby="salarioBase_80">
                <small id="salarioBase_80" class="form-text text-muted corFonte hint">* Campo obrigatório.</small>
              </div>
            </div>
            <div class="col-sm">
              <div class="form-group corFonte">
                <label for="HoraMes">Hora/Mês</label>
                <input type="number" [(ngModel)]="horaMes_80" class="form-control tamanhoCaixaTexto" id="HoraMes">
              </div>
            </div>
            <div class="col-sm">
              <div class="form-group corFonte">
                <label for="salarioBase">Hora</label>
                <input type="number" [(ngModel)]="hora_80" class="form-control tamanhoCaixaTexto" id="salarioBase">
              </div>
            </div>
            <div class="col-sm">
              <div class="form-group corFonte">
                <label for="Minuto">Minuto</label>
                <input type="number" min="0" max="59" [(ngModel)]="minuto_80" class="form-control tamanhoCaixaTexto"
                  id="Minuto">
              </div>
            </div>
          </div>
          <br>
          <div class="card-subtitle corFonte" style="font-family: Arial;">
            <h5 class="">Cálculo de horas extras para 100%</h5>
          </div>
          <div class="row">
            <div class="col-sm">
              <div class="form-group corFonte">
                <label for="salarioBase100">Salário Base</label>
                <input type="number" step="0.01" [(ngModel)]="salarioBase_100" class="form-control tamanhoCaixaTexto"
                  id="salarioBase100" aria-describedby="salario">
                <small id="salario" class="form-text text-muted corFonte hint">* Campo obrigatório.</small>
              </div>
            </div>
            <div class="col-sm">
              <div class="form-group corFonte">
                <label for="HoraMes">Hora/Mês</label>
                <input type="number" [(ngModel)]="horaMes_100" class="form-control tamanhoCaixaTexto" id="HoraMes">
              </div>
            </div>
            <div class="col-sm">
              <div class="form-group corFonte">
                <label for="salarioBase">Hora</label>
                <input type="number" [(ngModel)]="hora_100" class="form-control tamanhoCaixaTexto" id="salarioBase">
              </div>
            </div>
            <div class="col-sm">
              <div class="form-group corFonte">
                <label for="Minuto">Minuto</label>
                <input type="number" min="0" max="59" [(ngModel)]="minuto_100" class="form-control tamanhoCaixaTexto"
                  id="Minuto">
              </div>
            </div>
          </div>
          <br>
          <div class="card-subtitle corFonte" style="font-family: Arial;">
            <h5 class="">Cálculo de horas extras para 120%</h5>
          </div>
          <div class="row">
            <div class="col-sm">
              <div class="form-group corFonte">
                <label for="salarioBase120">Salário Base</label>
                <input type="number" step="0.01" [(ngModel)]="salarioBase_120" class="form-control tamanhoCaixaTexto"
                  id="salarioBase120" aria-describedby="salario">
                <small id="salario" class="form-text text-muted corFonte hint">* Campo obrigatório.</small>
              </div>
            </div>
            <div class="col-sm">
              <div class="form-group corFonte">
                <label for="HoraMes">Hora/Mês</label>
                <input type="number" [(ngModel)]="horaMes_120" class="form-control tamanhoCaixaTexto" id="HoraMes">
              </div>
            </div>
            <div class="col-sm">
              <div class="form-group corFonte">
                <label for="salarioBase">Hora</label>
                <input type="number" [(ngModel)]="hora_120" class="form-control tamanhoCaixaTexto" id="salarioBase">
              </div>
            </div>
            <div class="col-sm">
              <div class="form-group corFonte">
                <label for="Minuto">Minuto</label>
                <input type="number" min="0" max="59" [(ngModel)]="minuto_120" class="form-control tamanhoCaixaTexto"
                  id="Minuto">
              </div>
            </div>
          </div>
          <br>

          <div class="card-subtitle corFonte" style="font-family: Arial;">
            <h5 class="">Cálculo para feriado</h5>
          </div>
          <div class="row">
            <div class="col-sm">
              <div class="form-group corFonte">
                <label for="salarioBaseFeriado">Salário Base</label>
                <input type="number" step="0.01" [(ngModel)]="salarioBase_Feriado"
                  class="form-control tamanhoCaixaTexto" id="salarioBaseFeriado" aria-describedby="salario">
                <small id="salario" class="form-text text-muted corFonte hint">* Campo obrigatório.</small>
              </div>
            </div>
            <div class="col-sm">
              <div class="form-group corFonte">
                <label for="HoraMes">Hora/Mês</label>
                <input type="number" [(ngModel)]="horaMes_Feriado" class="form-control tamanhoCaixaTexto" id="HoraMes">
              </div>
            </div>
            <div class="col-sm">
              <div class="form-group corFonte">
                <label for="salarioBase">Hora</label>
                <input type="number" [(ngModel)]="hora_Feriado" class="form-control tamanhoCaixaTexto" id="salarioBase">
              </div>
            </div>
            <div class="col-sm">
              <div class="form-group corFonte">
                <label for="Minuto">Minuto</label>
                <input type="number" min="0" max="59" [(ngModel)]="minuto_Feriado"
                  class="form-control tamanhoCaixaTexto" id="Minuto">
              </div>
            </div>
          </div>
          <br>
          <div class="card-subtitle corFonte" style="font-family: Arial;">
            <h5 class="">Informar os dias para cálcular DSR</h5>
          </div>
          <div class="row">
            <div class="col-sm-3 col-md-3 col-lg-3">
              <div class="form-group corFonte">
                <label for="DiasUteis">Dias Úteis</label>
                <input type="number" [(ngModel)]="diasUteis" class="form-control " id="DiasUteis">
              </div>
            </div>
            <div class="col-sm-5 col-md-5 col-lg-5"></div>
            <div class="col-sm-4 col-md-4 col-lg-4">
              <div class="form-group corFonte">
                <label for="Repouso">Dias de Repouso</label>
                <input type="number" [(ngModel)]="diasRepouso" class="form-control" id="Repouso">
              </div>
            </div>
          </div>
          <div class="card-subtitle corFonte" style="font-family: Arial;">
            <h5 class="">Calculo para Salário</h5>
          </div>
          <div class="row">
            <div class="col-sm-3 col-md-3 col-lg-3">
              <div class="form-group corFonte">
                <label for="SalarioBaseSalario">Salário</label>
                <input type="number" [(ngModel)]="salarioBaseSalario" class="form-control tamanhoCaixaTexto"
                  id="SalarioBaseSalario">
              </div>
            </div>
            <div class="col-sm-5 col-md-5 col-lg-5"></div>
            <div class="col-sm-4 col-md-4 col-lg-4">
              <div class="form-group corFonte">
                <label for="DiasSalario">Dias Trabalhados</label>
                <input type="number" [(ngModel)]="diasSalario" class="form-control tamanhoCaixaTexto" id="DiasSalario">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <br>
    <div class="col-lg-3">
      <button type="button" class="btn btn-sm botaoCalcularFocus"
        (click)="Calcular() == 'ok' ? staticModal.show() : staticModal.hide()">Calcular Horas
        Extras</button>
    </div>
  </div>
</div>



<div class="modal fade" bsModal #staticModal="bs-modal" [config]="{backdrop: 'static'}" tabindex="-1" role="dialog"
  aria-labelledby="dialog-static-name">
  <div class="modal-dialog modal-md">
    <div class="modal-content">
      <div class="modal-header">
        <h4 id="dialog-static-name" class="modal-title pull-left">Resultado do Cálculo</h4>
        <button type="button" class="close pull-right" aria-label="Close" (click)="staticModal.hide()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <ul class="list-group">
          <li class="list-group-item d-flex justify-content-between align-items-center">
            Horas Extras 50%:
            <span class="align-self-end" style="font-weight: bold;">{{ valorTotalHoras_50 | currency:"R$ "}}</span>
          </li>
          <li class="list-group-item d-flex justify-content-between align-items-center">
            Horas Extras 80%:
            <span class="align-self-end" style="font-weight: bold;">{{ valorTotalHoras_80 | currency:"R$ "}}</span>
          </li>
          <li class="list-group-item d-flex justify-content-between align-items-center">
            Horas Extras 100%:
            <span class="align-self-end" style="font-weight: bold;">{{ valorTotalHoras_100 | currency:"R$ "}}</span>
          </li>
          <li class="list-group-item d-flex justify-content-between align-items-center">
            Horas Extras 120%:
            <span class="align-self-end" style="font-weight: bold;">{{ valorTotalHoras_120 | currency:"R$ "}}</span>
          </li>
          <li class="list-group-item d-flex justify-content-between align-items-center">
            Feriado:
            <span class="align-self-end" style="font-weight: bold;">{{ valorTotalFeriado | currency:"R$ "}}</span>
          </li>
          <li class="list-group-item d-flex justify-content-between align-items-center">
            DSR:
            <span class="align-self-end" style="font-weight: bold;">{{ valorTotalDsr | currency:"R$ "}}</span>
          </li>
          <li class="list-group-item d-flex justify-content-between align-items-center">
            Salário:
            <span class="align-self-end" style="font-weight: bold;">{{ valorTotalSalarioDiario | currency:"R$ "}}</span>
          </li>
          <li class="list-group-item d-flex justify-content-between align-items-center">
            Valor à Pagar:
            <span
              style="font-weight: bold; font-size: x-large; color: blue;">{{ valorTotalPagamento | currency:"R$ " }}</span>
          </li>
        </ul>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-sm botaoCalcularFocus"
          (click)="staticModal.hide(); staticModal2.show();">Emitir Recibo</button>
        <button type="button" class="btn btn-sm botaoCalcularFocus" (click)="staticModal.hide()">Fechar</button>
      </div>
    </div>
  </div>
</div>




<div class="modal fade" bsModal #staticModal2="bs-modal" [config]="{backdrop: 'static'}" tabindex="-1" role="dialog"
  aria-labelledby="dialog-static-name">
  <div class="modal-dialog modal-md">
    <div class="modal-content">
      <div class="modal-header">
        <h4 id="dialog-static-name" class="modal-title pull-left">Informações Gerais</h4>
        <button type="button" class="close pull-right" aria-label="Close" (click)="staticModal2.hide()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-sm">

            <div class="form-row">
              <div class="col-lg">
                <label for="razaoSocial1">Razão Social</label>
                <input required type="text" [(ngModel)]="razaoSocial" class="form-control tamanhoCaixaTexto"
                  id="razaoSocial1" aria-describedby="razaoSocial1">
                <small id="razaoSocial2" class="form-text text-muted corFonte hint">* Campo obrigatório.</small>
              </div>
              <div class="col-lg">
                <label for="funcionario1">Funcionário</label>
                <input required type="text" [(ngModel)]="funcionario" class="form-control tamanhoCaixaTexto"
                  id="funcionario1" aria-describedby="funcionario1">
                <small id="funcionario2" class="form-text text-muted corFonte hint">* Campo obrigatório.</small>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-sm botaoCalcularFocus" (click)="GerarPdf(); staticModal2.hide();">Gerar Recibo em PDF</button>
        <button type="button" class="btn btn-sm botaoCalcularFocus" (click)="validarRecibo(); staticModal2.hide();">Gerar Recibo</button>
        <button type="button" class="btn btn-sm botaoCalcularFocus" (click)="staticModal2.hide()">Fechar</button>
      </div>
    </div>
  </div>
</div>